import { disconnectSettingsCalendarApi as generatedDisconnectSettingsCalendarApi } from '../generated/settingsCalendar/disconnectSettingsCalendar';

const disconnectSettingsCalendarApi = generatedDisconnectSettingsCalendarApi.enhanceEndpoints({
  endpoints: {
    disconnectSettingsCalendar: {
      invalidatesTags: ['SettingsCalendar'],
    },
  },
});

export const { useDisconnectSettingsCalendarMutation } = disconnectSettingsCalendarApi;
